import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector, Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Grid from '@material-ui/core/Grid';
import ListItemText from '@material-ui/core/ListItemText';
import SvgIcon from '@material-ui/core/SvgIcon';
import { FixedSizeList } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import { ReactComponent as IgnitionIcon } from './assets/images/ignition.svg';
// import { useTheme } from '@material-ui/core/styles';
import moment from 'moment';

import store, { devicesActions, layoutActions } from './store';
import EditCollectionView from './EditCollectionView';
import { getPosition, getUserDevices } from './common/selectors';
import StatusView from './map/StatusView';
import theme from './theme';
import { useHistory, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import { map } from './map/Map';
import * as maptiler from '@maptiler/sdk';
import '@maptiler/sdk/dist/maptiler-sdk.css';
import { api_call, console_log, empty, getDeviceImageUri, get_utc_timestamp_ms, updatePageQuery } from './helpers/untils';
import { DEVICE_PAYMENT_STATUS } from './config/constant';
import { checkDeviceCanBeShownInMap, checkDeviceIsOnline, checkShowPaypalBanner } from './helpers/misc';

const useStyles = makeStyles((theme) => ({
  list: {
    maxHeight: '100%',
  },
  listInner: {
    position: 'relative',
    margin: theme.spacing(1.5, 0),
  },
  icon: {
    width: '25px',
    height: '25px',
    filter: 'brightness(0) invert(1)',
  },
  avatar: {
    width: '25px',
    height: '25px',
    transform: 'scale(2)'
  },
  listItem: {
    backgroundColor: 'white',
    '&:hover': {
      backgroundColor: 'white',
    },
  },
  batteryText: {
    fontSize: '0.75rem',
    fontWeight: 'normal',
    lineHeight: '0.875rem',
  },
  green: {
    color: theme.palette.common.Green,
  },
  red: {
    color: theme.palette.common.Red,
  },
  gray: {
    color: theme.palette.common.Gray,
  },
  offline: {
    color: '#BFBDBD',
  },
  indicators: {
    lineHeight: 1,
    cursor: 'pointer'
  },
}));

const getStatusColor = (status) => {
  switch (status) {
    case 'online':
      return 'green';
    case 'offline':
      return 'offline';
    case 'unknown':
    default:
      return 'gray';
  }
};

const getCreditColor = (credit) => {
  var credit_float = parseFloat(credit);
  if (credit_float <= 0) {
    return 'green';
  } else if (credit_float > 0 && credit_float < 15) {
    return 'gray'
  } else {
    return 'red';
  }
};

const getBatteryStatus = (batteryLevel) => {
  if (batteryLevel >= 70) {
    return 'green';
  }
  if (batteryLevel > 30) {
    return 'gray';
  }
  return 'red';
};

const DeviceRow = (props) => {
  const { data, index, style } = props
  const history = useHistory();
  const location = useLocation();
  const classes = useStyles();
  const dispatch = useDispatch();

  const { items, showPaypalCreditLogsPage, showDeviceCreditLogsPage, showDeviceAvatarPage, popupRef, onClickDeviceRow } = data;
  const item = items[index];
  const position = useSelector(getPosition(item.id));
  const showIgnition = position?.hasOwnProperty('ignition') && position?.ignition;

  ////////////////////////////////addition moovetrax modal////////////////////////////////
  const deviceItem = { ...item } // [deviceItem, setDeviceItem] = useState(item);

  ////////////////////////////////////////////////////////////////////////////////

  const showFilePopup = (device_tem) => {
    showDeviceAvatarPage(device_tem)
  }

  const onClickDeviceBalance = async () => {
    console_log(`onClickDeviceBalance:::::`)

    let userDeviceItem = null
    ////////////////////////start paypal credit log modal//////////////////////////////////////
    // we only suggest subscriotion // 
    const url = `/api/device-check-charge-required/${item.id}`
    const apiRes = await api_call(url);
    if (apiRes.ok) {
      const apiResObj = await apiRes.json()
      console.log("apiResObj::::", apiResObj)
      userDeviceItem = apiResObj['device']
      let chargeRequired = apiResObj['charge_required']
      if (chargeRequired === DEVICE_PAYMENT_STATUS.PAYMENT_REQUIRED) {
        if (typeof showPaypalCreditLogsPage === 'function') {
          showPaypalCreditLogsPage(userDeviceItem, chargeRequired)
          return false
        }
      } else if (chargeRequired === DEVICE_PAYMENT_STATUS.PAYMENT_REMINDER) {
        if (checkShowPaypalBanner(item.id)) {
          if (typeof showPaypalCreditLogsPage === 'function') {
            showPaypalCreditLogsPage(userDeviceItem, chargeRequired)
            return false
          }
        }
      }
    } else {
      alert("Invalid request")
      return false
    }

    if (empty(userDeviceItem)) {
      return false
    }

    /////////////////////////////////////////////////////////////////
    showDeviceCreditLogsPage(userDeviceItem)
  }

  return (
    <div style={style} key={item.id}>
      <ListItem button key={item.id} className={classes.listItem} onClick={async () => { return false }}>
        <ListItemAvatar>
          <Avatar onClick={() => showFilePopup(item)}>
            <img className={deviceItem.image ? classes.avatar : classes.icon} src={getDeviceImageUri(deviceItem, true)} alt="" />
          </Avatar>
        </ListItemAvatar>

        <ListItemText
          onClick={() => onClickDeviceRow(item.id, true)}
          primary={<span className={`${item.deviceType}-primary-color text-emphasis`} style={{ color: item.deviceTextColor || '' }}>{`${item.name}`}</span>}
          secondary={`${item.status === 'offline' ? 'offline \u00A0 ' + (item.lastConnect ? moment(item.lastConnect).format('YYYY-MM-DD HH:mm') : '') : item.status}`}
          classes={{ secondary: classes[getStatusColor(item.status)] }}
        />

        <ListItemSecondaryAction className={classes.indicators} onClick={() => onClickDeviceBalance()}>
          <Grid container direction="row" alignItems="center" alignContent="center" spacing={2}>
            {showIgnition && (
              <Grid item>
                <SvgIcon component={IgnitionIcon} />
              </Grid>
            )}
            <ListItemText secondary={`${item.credit}`} classes={{ secondary: classes[getCreditColor(item.credit)] }} />
          </Grid>
        </ListItemSecondaryAction>
      </ListItem>
    </div>
  );
};

const DeviceView = ({ updateTimestamp, onMenuClick, filter, updateDeviceCountData, showPaypalCreditLogsPage, showDeviceCreditLogsPage, showDeviceAvatarPage, popupRef }) => {
  const history = useHistory();
  const location = useLocation();
  const classes = useStyles();
  const dispatch = useDispatch();

  const devices = useSelector((state) => Object.values(state.devices.items));
  const currentDeviceSortKey = useSelector((state) => state.layout.currentDeviceSortKey);
  const currentDeviceSortOrder = useSelector((state) => state.layout.currentDeviceSortOrder);
  //console.log("currentDeviceSortKey::::", currentDeviceSortKey)

  const listInnerEl = useRef(null);
  const user = useSelector((state) => state.session.user);
  const items = useSelector(getUserDevices);
  // console_log("deviceListMenu device items:::::::::::::::", items);
  const [filteredItems, setFilteredItems] = useState(null);

  const currentDeviceId = useSelector((state) => state.layout.currentDeviceId);
  useEffect(() => {
    if (currentDeviceId) {
      setTimeout(() => {
        onClickDeviceRow(currentDeviceId)
      }, 2000)
    }
  }, [currentDeviceId]);

  const sortWithAttributeAlphabetical = (a, b) => {
    if (currentDeviceSortOrder === "asc") {
      if (a === "") {
        return 1
      }
      else if (b === "") {
        return -1
      }
      else {
        return a.localeCompare(b)
      }
    } else {
      if (a === "") {
        return -1
      }
      else if (b === "") {
        return 1
      }
      else {
        return b.localeCompare(a)
      }
    }
  }

  const getSortedDeviceList = (device_list, sortKey = "") => {
    const deviceList = [...device_list]
    let sortedDeviceList = []

    if (sortKey === "Installation") {
      if (currentDeviceSortOrder === "asc") {
        sortedDeviceList = deviceList.sort((a, b) => Number(a.id) - Number(b.id));
      } else {
        sortedDeviceList = deviceList.sort((b, a) => Number(a.id) - Number(b.id));
      }
    }
    else if (sortKey === "Alphabetically") {
      if (currentDeviceSortOrder === "asc") {
        sortedDeviceList = deviceList.sort((a, b) => a?.name?.localeCompare(b?.name));
      } else {
        sortedDeviceList = deviceList.sort((b, a) => a?.name?.localeCompare(b?.name));
      }
    }
    else if (sortKey === "Balance") {
      if (currentDeviceSortOrder === "asc") {
        sortedDeviceList = deviceList.sort((a, b) => Number(b.credit) - Number(a.credit));
      } else {
        sortedDeviceList = deviceList.sort((b, a) => Number(b.credit) - Number(a.credit));
      }
    }
    else if (sortKey === "Online") {
      if (currentDeviceSortOrder === "asc") {
        sortedDeviceList = deviceList.sort((a, b) => {
          if (a.status === "online") {
            return -1
          }
          else if (b.status === "online") {
            return 1
          }
          else {
            const aLastConnectTimestamp = !empty(a.lastConnect) ? moment(a.lastConnect).unix() : 0
            const bLastConnectTimestamp = !empty(b.lastConnect) ? moment(b.lastConnect).unix() : 0
            if (aLastConnectTimestamp > bLastConnectTimestamp) {
              return -1
            }
            else if (aLastConnectTimestamp < bLastConnectTimestamp) {
              return 1
            } else {
              return 0
            }
          }
        })
      } else {
        sortedDeviceList = deviceList.sort((a, b) => {
          if (a.status === "online") {
            return 1
          }
          else if (b.status === "online") {
            return -1
          }
          else {
            const aLastConnectTimestamp = !empty(a.lastConnect) ? moment(a.lastConnect).unix() : 0
            const bLastConnectTimestamp = !empty(b.lastConnect) ? moment(b.lastConnect).unix() : 0
            if (aLastConnectTimestamp > bLastConnectTimestamp) {
              return 1
            }
            else if (aLastConnectTimestamp < bLastConnectTimestamp) {
              return -1
            } else {
              return 0
            }
          }
        })
      }
    }
    else if (sortKey === "Lock Status") {
      if (currentDeviceSortOrder === "asc") {
        sortedDeviceList = deviceList.sort((a, b) => {
          if (empty(a.lock_status_timestamp)) {
            return 1
          }
          else if (empty(b.lock_status_timestamp)) {
            return -1
          }
          else {
            return new Date(b.lock_status_timestamp) - new Date(a.lock_status_timestamp)
          }
        });
      } else {
        sortedDeviceList = deviceList.sort((b, a) => {
          if (empty(a.lock_status_timestamp)) {
            return 1
          }
          else if (empty(b.lock_status_timestamp)) {
            return -1
          }
          else {
            return new Date(b.lock_status_timestamp) - new Date(a.lock_status_timestamp)
          }
        });
      }

    }
    else if (sortKey === "Kill status") {
      if (currentDeviceSortOrder === "asc") {
        sortedDeviceList = deviceList.sort((a, b) => {
          if (empty(a.kill_status_timestamp)) {
            return 1
          }
          else if (empty(b.kill_status_timestamp)) {
            return -1
          }
          else {
            return new Date(b.kill_status_timestamp) - new Date(a.kill_status_timestamp)
          }
        });
      } else {
        sortedDeviceList = deviceList.sort((b, a) => {
          if (empty(a.kill_status_timestamp)) {
            return 1
          }
          else if (empty(b.kill_status_timestamp)) {
            return -1
          }
          else {
            return new Date(b.kill_status_timestamp) - new Date(a.kill_status_timestamp)
          }
        });
      }
    }
    else if (sortKey === "Make") {
      sortedDeviceList = deviceList.sort((a, b) => {
        return sortWithAttributeAlphabetical(a.make, b.make)
      })
    }
    else if (sortKey === "Model") {
      sortedDeviceList = deviceList.sort((a, b) => {
        return sortWithAttributeAlphabetical(a.model, b.model)
      })
    }
    else if (sortKey === "Color") {
      sortedDeviceList = deviceList.sort((a, b) => {
        return sortWithAttributeAlphabetical(a.color, b.color)
      })
    }
    else if (sortKey === "Category") {
      sortedDeviceList = deviceList.sort((a, b) => {
        return sortWithAttributeAlphabetical(a.category, b.category)
      })
    }
    else if (sortKey === "Miles") {
      if (currentDeviceSortOrder === "asc") {
        sortedDeviceList = deviceList.sort((a, b) => {
          if (empty(a.odometer)) {
            return -1
          }
          else if (empty(b.odometer)) {
            return 1
          }
          else {
            return Number(b.odometer) - Number(a.odometer)
          }
        });
      } else {
        sortedDeviceList = deviceList.sort((b, a) => {
          if (empty(a.odometer)) {
            return -1
          }
          else if (empty(b.odometer)) {
            return 1
          }
          else {
            return Number(b.odometer) - Number(a.odometer)
          }
        });
      }
    }
    else if (sortKey === "Vin") {
      sortedDeviceList = deviceList.sort((a, b) => {
        return sortWithAttributeAlphabetical(a.vin, b.vin)
      })
    }
    else {
      sortedDeviceList = deviceList
    }
    setFilteredItems(sortedDeviceList);
    return sortedDeviceList
  }

  const sortDeviceList = (device_list, sortKey = "") => {
    if (sortKey === "") {
      sortKey = currentDeviceSortKey
    }
    //sortKey = "Balance" // for testing
    const deviceList = [...device_list]
    const sortedDeviceList = getSortedDeviceList(deviceList, sortKey) // useMemo(() => getSortedDeviceList(deviceList, sortKey), [deviceList, sortKey]);
    setFilteredItems(sortedDeviceList);
    return sortedDeviceList
  }

  useEffect(() => {
    if (filteredItems && filteredItems.length > 0) {
      sortDeviceList([...filteredItems], currentDeviceSortKey)
    }
  }, [currentDeviceSortKey])

  useEffect(() => {
    let filtered_device_list = []
    if (filter.toLowerCase() === 'none') {
      filtered_device_list = items ? items.filter((item) => (empty(item.users) || item.users.length === 0)) : []
    } else {
      filtered_device_list = filter.trim().length > 0 ? items.filter((item) => `${item.name} ${item.uniqueId} ${item.vin} ${item.license_tag} ${item.iccid} ${item.user_email_list_str}`.toLowerCase().includes(filter.trim().toLowerCase())) : items
    }

    filtered_device_list = sortDeviceList([...filtered_device_list], currentDeviceSortKey)

    const online_device_list = items ? items.filter((item) => {
      return checkDeviceIsOnline(item)
    }) : []

    const inside_map_device_list = items ? items.filter((item) => {
      return checkDeviceCanBeShownInMap(item)
    }) : []

    const deviceCountData = {
      device_count: items ? items.length : 0,
      filtered_device_count: filtered_device_list ? filtered_device_list.length : 0,
      online_device_count: online_device_list.length,
      inside_map_device_count: inside_map_device_list.length,
    }
    updateDeviceCountData(deviceCountData)

  }, [filter, items]);

  if (listInnerEl.current) {
    listInnerEl.current.className = classes.listInner;
  }

  const [mapBoundaryInitialized, setMapBoundaryInitialized] = useState(false)
  const calculateMapBoundary = async (devices) => {
    console.log("::::: devices:::::", devices.length)
    if (devices.length) {
      if (! /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        //map.setPadding({ left: parseInt(theme.dimensions.drawerWidthDesktop, 10) }); //quan code
      }
      var points = [];
      devices.forEach((device) => { if (device.longitude && device.latitude) points.push([device.longitude, device.latitude]) });
      if (points.length === 1) {
        //map.easeTo({center: points[0], zoom: 18});
        var coordinates = [];
        const diff = 0.03;
        coordinates.push([points[0][0] - diff, points[0][1] - diff])
        coordinates.push([points[0][0] + diff, points[0][1] + diff])
        var bounds = coordinates.reduce(function (bounds, coord) {
          return bounds.extend(coord);
        }, new maptiler.LngLatBounds(coordinates[0], coordinates[0]));
        map.fitBounds(bounds, { padding: { top: 50, bottom: 50, left: 50, right: 50 } });
      }
      else {
        var coordinates = points;
        var bounds = coordinates.reduce(function (bounds, coord) {
          return bounds.extend(coord);
        }, new maptiler.LngLatBounds(coordinates[0], coordinates[0]));
        map.fitBounds(bounds, { padding: { top: 50, bottom: 50, left: 50, right: 50 } });
      }
      setMapBoundaryInitialized(true)
    }

  }
  useEffect(() => {
    if (!mapBoundaryInitialized) {
      calculateMapBoundary(items)
    }
  }, [items]);

  const onClickDeviceRow = async (itemId, manualClicked) => {
    console.log("currentDeviceId=>", currentDeviceId, manualClicked);
    console.log("itemId=>", itemId);
    let userDeviceItem = null

    ////////////////////////start paypal credit log modal//////////////////////////////////////
    const url = `/api/device-check-charge-required/${itemId}`
    const apiRes = await api_call(url);
    if (apiRes.ok) {
      const apiResObj = await apiRes.json()
      console.log("ChargeapiResObj::::", apiResObj)
      userDeviceItem = apiResObj['device']

      let chargeRequired = apiResObj['charge_required']
      if (chargeRequired === DEVICE_PAYMENT_STATUS.PAYMENT_REQUIRED) {
        if (typeof showPaypalCreditLogsPage === 'function') {
          showPaypalCreditLogsPage(userDeviceItem, chargeRequired)
          return false
        }
      } else if (chargeRequired === DEVICE_PAYMENT_STATUS.PAYMENT_REMINDER) {
        if (checkShowPaypalBanner(itemId)) {
          if (typeof showPaypalCreditLogsPage === 'function') {
            showPaypalCreditLogsPage(userDeviceItem, chargeRequired)
            return false
          }
        }
      }
    } else {
      alert("Invalid request")
      return false
    }

    if (empty(userDeviceItem)) {
      return false
    }

    const selectedDeviceId = userDeviceItem.id;
    const selectedDevice = devices.find((item) => item.id === selectedDeviceId) // get device info from websocket data
    if (empty(selectedDevice)) {
      return false;
    }

    ////////////////////////end paypal credit log modal//////////////////////////////////////

    dispatch(devicesActions.select(selectedDevice));
    dispatch(layoutActions.closeDeviceListMenu());
    dispatch(layoutActions.setCurrentDeviceId({ id: 0 }));
    dispatch(layoutActions.setDeviceReloadTimestamp({ value: get_utc_timestamp_ms() }));

    const queryParam = {
      deviceId: userDeviceItem.id
    }
    if (!manualClicked) {
      const page = localStorage.getItem('page');
      if (page && page !== 'null') {
        queryParam['page'] = page;
      }
    }
    updatePageQuery(location.search, queryParam);

    if (true || userDeviceItem.status === 'online' || userDeviceItem.status === 'offline') { //all devices are clickable
      const placeholder = document.createElement('div');
      ReactDOM.render(
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <StatusView
              deviceId={userDeviceItem.id}
              address={``}
              lat={userDeviceItem?.latitude}
              lng={userDeviceItem?.longitude}
              onShowDetails={(positionId) => history.push(`/position/${positionId}`)}
              onShowHistory={(deviceId) => history.push(`/replay/${deviceId}`)}
              onEditClick={(deviceId) => history.push(`/device/${deviceId}`)}
              onLogClick={(deviceId) => history.push(`/reports/event/${deviceId}`)}
              onClosePopup={(deviceId) => onClosePopup(deviceId)}
              history={history}
              location={location}
              userDeviceItem={userDeviceItem}
            />
          </ThemeProvider>
        </Provider>,
        placeholder,
      );

      if (popupRef.current) {
        // console_log(`popupRef.current:::::`, popupRef.current)
        popupRef.current.remove();
        popupRef.current = null;
      }

      popupRef.current = new maptiler.Popup({
        offset: 25,
        anchor: 'top'
      }).setDOMContent(placeholder)
        .setLngLat([selectedDevice.longitude, selectedDevice.latitude])
        .addTo(map);
    }
  }

  return (
    <AutoSizer className={classes.list}>
      {({ height, width }) => (
        <List disablePadding>
          <FixedSizeList
            width={width}
            height={height}
            itemCount={filteredItems.length}
            itemData={{ items: filteredItems, showPaypalCreditLogsPage, showDeviceCreditLogsPage, showDeviceAvatarPage, onMenuClick, onClickDeviceRow, popupRef }}
            itemSize={72}
            itemKey={index => {
              return index;
            }}
            overscanCount={10} //{filteredItems.length} //10
            innerRef={listInnerEl}
          >
            {DeviceRow}
          </FixedSizeList>
        </List>
      )}
    </AutoSizer>
  );
};

const DevicesList = ({ filter, updateDeviceCountData, showPaypalCreditLogsPage, showDeviceCreditLogsPage, showDeviceAvatarPage }) => {
  const popupRef = useRef(null);

  const mapCenter = useSelector((state) => {
    if (state?.devices?.selectedId) {
      const position = state.devices.items[state.devices.selectedId] || null;
      if (position && position.id) {
        return { deviceId: state.devices.selectedId, position: [position.longitude, position.latitude] };
      }
    }
    return null;
  });

  useEffect(() => {
    if (mapCenter && mapCenter?.position && popupRef.current) {
      popupRef.current.setLngLat(mapCenter.position);
    }
  }, [mapCenter])

  return (
    <EditCollectionView
      content={DeviceView}
      editPath="/device"
      endpoint="devices"
      disableAdd
      filter={filter}
      updateDeviceCountData={updateDeviceCountData}
      showPaypalCreditLogsPage={showPaypalCreditLogsPage}
      showDeviceCreditLogsPage={showDeviceCreditLogsPage}
      showDeviceAvatarPage={showDeviceAvatarPage}
      popupRef={popupRef}
    />
  )
};

export default DevicesList;
